export const GET_SUBSCRIPTIONS_REQUEST = '@subscriptions/GET_SUBSCRIPTIONS_REQUEST';
export const GET_SUBSCRIPTIONS_SUCCESS = '@subscriptions/GET_SUBSCRIPTIONS_SUCCESS';
export const GET_SUBSCRIPTIONS_ERROR = '@subscriptions/GET_SUBSCRIPTIONS_ERROR';

export const CREATE_CHECKOUT_SESSION_REQUEST = '@subscriptions/CREATE_CHECKOUT_SESSION_REQUEST';
export const CREATE_CHECKOUT_SESSION_SUCCESS = '@subscriptions/CREATE_CHECKOUT_SESSION_SUCCESS';
export const CREATE_CHECKOUT_SESSION_ERROR = '@subscriptions/CREATE_CHECKOUT_SESSION_ERROR';
